<template>
  <div class="animation-container" :class="{ horizontal, paused }" @click="paused = !paused">
    <slot />
  </div>
</template>

<script>

export default {
  props: {
    horizontal: { type: Boolean },
  },
  data() {
    return {
      paused: false,
    };
  },
};
</script>

<style lang="scss">
.animation-container {
  animation: vertical-sliding 20s linear infinite;

  &.horizontal {
    animation: horizontal-sliding 220s linear infinite;
  }

  &:hover {
    -webkit-animation-play-state: paused;
    animation-play-state: paused;
  }
}

@keyframes vertical-sliding {
  0% {
    transform: translateY(0);
  }

  100% {
    transform: translateY(-50%);
  }
}

@keyframes horizontal-sliding {
  0% {
    transform: translateX(0);
  }

  100% {
    transform: translateX(-50%);
  }
}

@include bp($bp-mobile) {
  .animation-container {
    &:hover {
      -webkit-animation-play-state: running;
      animation-play-state: running;
    }

    &.paused {
      -webkit-animation-play-state: paused;
      animation-play-state: paused;
    }
  }
}
</style>
